// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-module__spinner--jctP_","bigCircle":"Spinner-module__bigCircle--__bET","smallCircle":"Spinner-module__smallCircle--pR5J8","eyes":"Spinner-module__eyes--t91hP"};